import { useState } from "react";
import { ChevronDown, CalendarPlus, History, BadgeCheck, Archive, Trash2 } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
  DropdownMenuSub, DropdownMenuSubTrigger, DropdownMenuSubContent,
} from "@/components/ui/dropdown-menu";
import { ActionSheet, useMobile } from "@/components/ActionSheet";

const item = "py-2 text-[14px] cursor-pointer";

const sheetItems = (menu) => [
  menu.cal && { label: "Google Calendar", hint: "Adicionar a escritura ao calendário", icon: CalendarPlus, onClick: menu.cal.google, testid: "more-cal-google" },
  menu.cal && { label: "Outlook / iPhone (.ics)", hint: "Adicionar a escritura ao calendário", icon: CalendarPlus, onClick: menu.cal.ics, testid: "more-cal-ics" },
  { label: `Histórico (${menu.historyCount})`, icon: History, onClick: menu.historico, testid: "more-historico" },
  ...(menu.panels || []).map((x) => ({ label: x.label, icon: x.icon, onClick: x.onClick, testid: x.testid })),
  menu.escritura && { label: "Marcar escritura realizada", icon: BadgeCheck, onClick: menu.escritura, testid: "mark-escriturado-btn" },
  menu.semVenda && { label: "Encerrar sem venda", hint: "Pede o motivo", icon: Archive, onClick: menu.semVenda, testid: "sem-venda-btn" },
  menu.anular && { label: "Anular processo", hint: "Pede confirmação", icon: Trash2, onClick: menu.anular, testid: "anular-processo-btn", danger: true },
];

export function MoreMenu({ menu, block = false, title = "Mais ações" }) {
  const mobile = useMobile();
  const [open, setOpen] = useState(false);
  const g3 = menu.escritura || menu.semVenda;
  const trigger = (
    <button data-testid="more-actions-btn" onClick={mobile ? () => setOpen(true) : undefined}
      className={`inline-flex items-center justify-center gap-1 text-[15px] font-medium px-5 h-12 md:h-11 rounded-[14px] border border-slate-200 bg-white text-ec-green hover:bg-slate-50 ${block ? "w-full" : ""}`}>
      Mais <ChevronDown size={15} />
    </button>
  );
  if (mobile) return <>{trigger}<ActionSheet open={open} onOpenChange={setOpen} title={menu.title || title} items={sheetItems(menu)} testid="more-actions" /></>;
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={6} className="w-64 bg-white" data-testid="more-actions">
        {menu.cal && (
          <DropdownMenuSub>
            <DropdownMenuSubTrigger className={item} data-testid="more-cal"><CalendarPlus size={15} className="mr-2" /> Adicionar ao calendário</DropdownMenuSubTrigger>
            <DropdownMenuSubContent className="bg-white">
              <DropdownMenuItem className={item} onClick={menu.cal.google} data-testid="more-cal-google">Google Calendar</DropdownMenuItem>
              <DropdownMenuItem className={item} onClick={menu.cal.ics} data-testid="more-cal-ics">Outlook / iPhone (.ics)</DropdownMenuItem>
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        )}
        <DropdownMenuItem className={item} onClick={menu.historico} data-testid="more-historico"><History size={15} className="mr-2" /> Histórico ({menu.historyCount})</DropdownMenuItem>
        {(menu.panels || []).map((x) => <DropdownMenuItem key={x.testid} className={item} onClick={x.onClick} data-testid={x.testid}>{x.icon && <x.icon size={15} className="mr-2" />}{x.label}</DropdownMenuItem>)}
        {g3 && <DropdownMenuSeparator />}
        {menu.escritura && <DropdownMenuItem className={item} onClick={menu.escritura} data-testid="mark-escriturado-btn"><BadgeCheck size={15} className="mr-2" /> Marcar escritura realizada</DropdownMenuItem>}
        {menu.semVenda && <DropdownMenuItem className={`${item} items-start`} onClick={menu.semVenda} data-testid="sem-venda-btn"><Archive size={15} className="mr-2 mt-0.5" /><span><span className="block">Encerrar sem venda</span><span className="block text-xs text-slate-500">Pede o motivo</span></span></DropdownMenuItem>}
        {menu.anular && <DropdownMenuSeparator />}
        {menu.anular && <DropdownMenuItem className={`${item} text-red-600 focus:text-red-700 focus:bg-red-50`} onClick={menu.anular} data-testid="anular-processo-btn"><Trash2 size={15} className="mr-2" /> Anular processo</DropdownMenuItem>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
